import type { PlatformToast, PlatformToastApi } from '@platform/plugin-platform-react';

type Listener = (toast: PlatformToast & { id: string }) => void;

/** Émetteur en mémoire : `ToastHost` s'y abonne, les surveillants y publient. */
export class PlatformToastClient implements PlatformToastApi {
  private readonly listeners = new Set<Listener>();

  post(toast: PlatformToast): void {
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;
    for (const listener of this.listeners) listener({ ...toast, id });
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }
}
